import { CalendarIcon } from "@heroicons/react/outline";
import React, { useEffect, useRef, useState } from "react";
import Input from "../Input";
import Picker from "./Picker";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import Dayjs from 'dayjs'


interface DateProps {
  className?: string;
  id?: string;
  placehodler?: string;
  format?: string;
  value?: string;
  handleDateChange: (date: string) => void;
}
const DatePicker: React.FC<DateProps> = ({
  className,
  id,
  placehodler,
  format = 'YYYY-MM-DD',
  value = '',
  handleDateChange
}) => {
  const [showPicker, setShowPicker] = useState(false)
  const dateContainerRef = useRef(null)
  // 点击非date 组件区域，关闭picker
  const clickOutsideHandler = () => setShowPicker(false);
  useOnClickOutside(dateContainerRef, clickOutsideHandler);

  const [checkedDateString, setCheckedDateString] = useState(value || '')
  useEffect(() => {
    setCheckedDateString(value)
  }, [value])

  const handleCheckedDate = (date: Date) => {
    const dateString = Dayjs(date).format(format)
    setCheckedDateString(dateString)
    setShowPicker(false)
    handleDateChange?.(dateString)
  }
  return (
    <>
      <div className={`relative z-10 ${className ? className : ''}`}
        id={id}
        ref={dateContainerRef}
      >
        <Input clear
          suffix={<CalendarIcon className="w-5" />}
          placeholder={placehodler}
          handleFocus={() => setShowPicker(true)}
          defaultValue={checkedDateString}
          readOnly
        />
        {
          showPicker && <Picker
            handleCheckedDate={handleCheckedDate}
            checkedDate={Dayjs(checkedDateString).toDate()}
          />
        }
      </div>

    </>
  )
}
export default DatePicker;
